import React from 'react';
import { BellIcon, ChevronLeftIcon, UserCircleIcon } from 'lucide-react';
import { motion } from 'framer-motion';
interface TopBarProps {
  title?: string;
  showBack?: boolean;
  onBack?: () => void;
  onNotificationClick?: () => void;
  onProfileClick?: () => void;
  unreadCount?: number;
  transparent?: boolean;
}
export function TopBar({
  title,
  showBack,
  onBack,
  onNotificationClick,
  onProfileClick,
  unreadCount = 3,
  transparent = false
}: TopBarProps) {
  const iconColor = transparent ? 'text-white' : 'text-[#0D3B3B]';
  const hoverBg = transparent ? 'hover:bg-white/10' : 'hover:bg-gray-100';
  return <div className={`px-4 py-4 flex items-center justify-between z-50 sticky top-0 ${transparent ? 'bg-transparent' : 'bg-slate-50/90 backdrop-blur-xl border-b border-gray-200/50'}`} data-id="element-855">
      <div className="flex items-center gap-3" data-id="element-856">
        {showBack ? <button onClick={onBack} className={`p-2 -ml-2 rounded-full ${hoverBg} transition-colors`} data-id="element-857">
            <ChevronLeftIcon className={`w-6 h-6 ${iconColor}`} data-id="element-858" />
          </button> : <button onClick={onProfileClick} className="w-10 h-10 rounded-full bg-[#FFD700] flex items-center justify-center text-[#0D3B3B] font-black shadow-sm border border-[#FFD700]/20 hover:opacity-90 transition-opacity" data-id="element-859">
            AO
          </button>}
        {title && <h1 className={`text-xl font-black tracking-tight ${iconColor}`} data-id="element-860">
            {title}
          </h1>}
      </div>

      <button onClick={onNotificationClick} className={`p-2 -mr-2 rounded-full ${hoverBg} transition-colors relative`} data-id="element-861">
        <BellIcon className={`w-6 h-6 ${iconColor}`} data-id="element-862" />
        {unreadCount > 0 && <motion.div initial={{
        scale: 0
      }} animate={{
        scale: 1
      }} className={`absolute top-1.5 right-2 w-2.5 h-2.5 bg-[#FFD700] rounded-full border-2 ${transparent ? 'border-transparent' : 'border-slate-50'}`} data-id="element-863" />}
      </button>
    </div>;
}